import styled from 'styled-components';
import { theme } from '@styles';

const { colors, fonts } = theme;

export const PrivacySection = styled.section`
  width: 100%;
  height: auto;
  padding: 3rem 0;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${colors.text};
  }
`;

export const StyledH4 = styled.h4`
  color: ${colors.text};
  font-size: 32px;
  line-height: 1;
  margin-bottom: 0.9em;
  margin-top: 1.5em;
  font-family: ${fonts.Secondary};
  font-weight: 400;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  word-break: break-word;
`;

export const StyledUL = styled.ul`
  color: ${colors.text};
  list-style: none;
  padding: 0;
  margin-top: 0;
  margin-bottom: 1rem;
`;

export const StyledLI = styled.li`
  font-size: 16px;
  font-weight: 300;
  line-height: 30px;
  padding: 4px 0 4px 25px;
  position: relative;
  color: ${colors.text};
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: ${colors.text};
  transition: all 0.2s ease-in-out 0s;

  :hover {
    color: ${colors.accent};
  }
`;
